import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  TextField,
  CircularProgress,
  Typography,
  Box,
} from "@mui/material";
import { get } from "../../utils/api";

const AirportAutocomplete = ({
  title,
  value, // Expecting an object { label, latitude, longitude } or a string (for existing data)
  onChange,
  error,
  disable,
  placeholder,
  titleDisabled = false,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [debounceTimeout, setDebounceTimeout] = useState(null);

  useEffect(() => {
    if (typeof value === "string") {
      setInputValue(value);
    } else if (value?.label) {
      setInputValue(value.label);
    } else {
      setInputValue("");
    }
  }, [value]);

  const handleInputChange = (event, newInputValue) => {
    setInputValue(newInputValue);

    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    const newTimeout = setTimeout(() => {
      if (newInputValue) {
        fetchAirports(newInputValue);
      } else {
        setOptions([]);
      }
    }, 500);

    setDebounceTimeout(newTimeout);
  };

  const fetchAirports = async (query) => {
    try {
      setLoading(true);
      let response = await get(
        `/scope3/airTransportation/search/airports?search=${query}`
      );
      setOptions(response?.data?.data || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching airports:", error);
      setLoading(false);
    }
  };

  const validationMessage =
    typeof error === "string" && error.trim() ? error : "";

  return (
    <Box>
      {!titleDisabled && (
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: "1rem" }}>
          {title}
        </Typography>
      )}
      <Autocomplete
        freeSolo
        options={options}
        disabled={disable}
        getOptionLabel={(option) => (option?.label ? option.label : "")}
        filterOptions={(x) => x || []}
        inputValue={inputValue}
        onInputChange={handleInputChange}
        onChange={(event, newValue) => {
          if (newValue) {
            setInputValue(newValue.label);
            onChange({
              label: newValue.label,
              latitude: newValue.latitude,
              longitude: newValue.longitude,
            });
          } else {
            setInputValue("");
            onChange(null);
          }
        }}
        size="small"
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            variant="outlined"
            placeholder={placeholder}
            error={Boolean(validationMessage)}
            helperText={validationMessage}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </Box>
  );
};

export default AirportAutocomplete;
